module.exports = __webpack_public_path__ + "img/dots_lightblue.e99aa497.png";